import { create } from 'zustand';
import { produce } from 'immer';
import { Group } from '~/src/types/groups';

interface State {
  groups: CachedValue<Group>[];
}

interface Action {
  add_groups: (groups: Group[]) => void;
}

export const usePeepStore = create<State & Action>((set) => ({
  groups: [],

  add_groups: (new_groups) =>
    set(
      produce((previous: State) => {
        for (const group of new_groups) {
          const idx = previous.groups.findIndex((g) => g.value.id === group.id);
          if (idx === -1) {
            // not pre-existing
            previous.groups.push({ inserted_at: new Date(), value: group });
          } else {
            // existing, replace
            previous.groups[idx] = { inserted_at: new Date(), value: group };
          }
        }
      }),
    ),
}));

interface CachedValue<V> {
  inserted_at: Date;
  value: V;
}
